<template>
  <!--坐标匹配页面-->
  <div class="main">
    <!-- 坐标匹配操作区 -->
    <a-card class="box-card">
      <!-- 表单区域 -->
      <div class="form-section">
        <div class="form-item">
          <span class="label">用户选择:</span>
          <a-select
            placeholder="请选择用户"
            @change="getdblist"
            v-model="phone"
            class="select-input"
            showSearch
            :filterOption="filterUserOption"
          >
            <a-select-option v-for="(item, index) in userlist" :key="index" :value="item.phone">
              {{ item.userName }} {{ item.phone }}
            </a-select-option>
          </a-select>
        </div>

        <div class="form-item">
          <span class="label">DB文件选择:</span>
          <a-select v-model="projectid" clearable placeholder="请选择DB文件" class="select-input">
            <a-select-option v-for="(item, index) in dblist" :key="index" :value="item.id">
              {{ item.projectName }}
            </a-select-option>
          </a-select>
        </div>

        <div class="form-item">
          <span class="label">坐标文件选择:</span>
          <a-input :disabled="true" v-model="file.name" class="select-input"></a-input>
          <a-upload :accept="'.txt'" name="file" :multiple="false" :beforeUpload="beforeUpload" :fileList="[]" >
            <a-button type="primary">选择坐标文件</a-button>
          </a-upload>
        </div>

        <div class="form-item">
          <a-button type="primary" @click="getmatching" class="preview-btn" >预览结果</a-button>
        </div>
      </div>

      <!-- 预览结果弹窗 -->
      <a-modal
        title="预览结果"
        :visible="PreviewResultsDigital"
        @cancel="confirmClosePreviewResults"
        :destroyOnClose="true"
        :footer="null"
        width="48%"
      >
        <div class="preview-content">
          <div class="tables-container">
            <div class="table-box" style="flex: 0 0 35%">
              <div class="table-title">采集项目点表</div>
              <a-table
                :scroll="{ y: 200 }"
                :dataSource="matchSucceededList"
                :columns="columns2"
                :bordered="true"
                :pagination="false"
              />
            </div>
            <div class="table-box" style="flex: 0 0 65%">
              <div class="table-title">坐标文件</div>
              <a-table
                :scroll="{ y: 200 }"
                :dataSource="dataSource"
                :bordered="true"
                :columns="columns"
                :pagination="false"
              />
            </div>
          </div>
          <div class="table-box bottom-table">
            <div class="table-title">匹配后结果预览</div>
            <a-table
              :scroll="{ y: 200 }"
              :dataSource="matchSucceededList"
              :bordered="true"
              :columns="columns3"
              :pagination="false"
            />
          </div>
        </div>
        <div class="modal-footer">
          <a-button type="primary" @click="showMatchingResults"> 查看匹配结果说明 </a-button>
          <div class="right-buttons">
            <!-- <a-button @click="PreviewResultsDigital = false">取 消</a-button> -->
            <a-button type="primary" @click="handleOk" > 写入数据库 </a-button>
          </div>
        </div>
      </a-modal>

      <!-- 匹配结果说明弹窗 -->
      <a-modal
        title="匹配结果说明"
        :visible="coordinateDialogVisible"
        @cancel="handleCancel"
        width="48%"
        :footer="null"
        :maskClosable="false"
      >
        <a-tabs defaultActiveKey="1">
          <!-- 缺少坐标的点 -->
          <a-tab-pane key="1" tab="缺少坐标">
            <div class="warning-box">
              <img src="@/assets/collectionMappingSystem/gth.png" class="warning-icon" />
              <div class="warning-text">以下管点没有找到对应的坐标</div>
            </div>

            <a-table
              :columns="missingCoordinatesColumns"
              :dataSource="matchFailedList"
              :rowSelection="{
                type: 'checkbox',
                selectedRowKeys: selectedMissingPoints,
                onChange: onPointSelectionChange,
                columnWidth: 60,
              }"
              :pagination="{
                current: matchingPagination.current,
                pageSize: matchingPagination.pageSize,
                total: matchingPagination.total,
                showTotal: (total) => `共 ${total} 条`,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50','100','200','500','1000'],
                onChange: handleMissingPageChange,
                onShowSizeChange: handleMissingPageChange,
              }"
              :rowKey="(record, index) => index"
              :scroll="{ y: 220 }"
              class="points-table"
            >
              <template slot="intuitionPoint" slot-scope="text">
                {{ text }}
              </template>
              <template slot="longitude" slot-scope="text, record">
                <a-input-number
                  v-model="record.measurementLongitude"
                  :precision="6"
                  style="width: 150px"
                  placeholder="请输入经度"
                  @change="() => handleCoordinateChange(record)"
                />
              </template>
              <template slot="latitude" slot-scope="text, record">
                <a-input-number
                  v-model="record.measurementLatitude"
                  :precision="6"
                  style="width: 150px"
                  placeholder="请输入纬度"
                  @change="() => handleCoordinateChange(record)"
                />
              </template>
              <template slot="groundHeight" slot-scope="text, record">
                <a-input-number
                  v-model="record.groundElevation"
                  :precision="3"
                  style="width: 100px"
                  placeholder="请输入高程"
                  @change="() => handleCoordinateChange(record)"
                />
              </template>
              <template slot="action" slot-scope="text, record">
                <a-button type="link" @click="handleDeletePoint(record)" v-action:del>删除</a-button>
              </template>
            </a-table>

            <div class="button-container" style="margin-top: 16px">
              <div>
                <a-button type="danger" @click="handleDeleteSelected" :disabled="!hasSelectedMissingPoints" v-action:del>
                  批量删除
                </a-button>
              </div>
              <div>
                <a-button
                  type="primary"
                  @click="handleUseFuzzyCoordinates"
                  :disabled="!hasSelectedMissingPoints"
                  style="margin-right: 8px"
                  v-action:edit
                >
                  使用模糊坐标
                </a-button>
                <a-button type="primary" @click="handleSavePoints" :disabled="!hasSelectedMissingPoints" v-action:add>
                  保存
                </a-button>
              </div>
            </div>
          </a-tab-pane>

          <!-- 物探点重复 -->
          <a-tab-pane key="2" tab="物探点重复">
            <div class="warning-box">
              <img src="@/assets/collectionMappingSystem/gth.png" class="warning-icon" />
              <div class="warning-text">以下物探点号重复</div>
            </div>
            <a-table
              :columns="duplicatePointsColumns"
              :dataSource="repeatList"
              :pagination="{
                current: duplicatePagination.current,
                pageSize: duplicatePagination.pageSize,
                total: duplicatePagination.total,
                showTotal: (total) => `共 ${total} 条`,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50','100','200','500','1000'],
                onChange: handleDuplicatePageChange,
                onShowSizeChange: handleDuplicatePageChange,
              }"
              :rowKey="(record, index) => index"
              :scroll="{ y: 220 }"
              :rowSelection="{
                selectedRowKeys: selectedDuplicatePoints,
                onChange: onDuplicatePointSelectionChange,
                getCheckboxProps: getDuplicateCheckboxProps,
                hideSelectAll: true,
                columnWidth: 60,
              }"
              :rowClassName="getDuplicateRowClassName"
            >
              <template slot="intuitionPoint" slot-scope="text">
                {{ text }}
              </template>
              <template slot="longitude" slot-scope="text, record">
                <a-input-number
                  v-model="record.measurementLongitude"
                  :precision="6"
                  style="width: 150px"
                  placeholder="请输入经度"
                  @change="() => handleDuplicateCoordinateChange(record)"
                />
              </template>
              <template slot="latitude" slot-scope="text, record">
                <a-input-number
                  v-model="record.measurementLatitude"
                  :precision="6"
                  style="width: 150px"
                  placeholder="请输入纬度"
                  @change="() => handleDuplicateCoordinateChange(record)"
                />
              </template>
              <template slot="groundHeight" slot-scope="text, record">
                <a-input-number
                  v-model="record.groundElevation"
                  :precision="3"
                  style="width: 100px"
                  placeholder="请输入高程"
                  @change="() => handleDuplicateCoordinateChange(record)"
                />
              </template>
              <template slot="action" slot-scope="text, record, index">
                <a-radio
                  :checked="selectedDuplicatePoints.includes(index)"
                  @change="() => handleUseDuplicatePoint(record, index)"
                  :disabled="!checkPointComplete(record)"
                >
                  使用
                </a-radio>
              </template>
            </a-table>
            <div class="table-footer">
              <div class="button-group">
                <a-button type="primary" @click="handleSaveDuplicatePoints" :disabled="!hasSelectedDuplicatePoints" v-action:add>
                  保存
                </a-button>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-modal>

      <!-- 加载动画组件 -->
      <loading-spinner :visible="submitting" :is-success="loadingSpinnerSuccess" />
    </a-card>

    <!-- 坐标匹配列表 -->
    <a-card :bordered="false" class="list-card">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="12">
              <a-form-item label="用户选择:">
                <a-select
                  v-model="query.phone"
                  placeholder="请选择用户"
                  allowClear
                  showSearch
                  :filterOption="filterUserOption"
                  @change="handleUserChange"
                >
                  <a-select-option v-for="item in userOptions" :key="item.id" :value="item.phone">
                    {{ item.userName + ' ' + item.phone }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="采集项目名称:">
                <a-input v-model="query.projectName" placeholder="请输入项目名称"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="匹配状态:">
                <a-select placeholder="请选择状态" style="width: 200px" v-model="query.matchStatus">
                  <a-select-option value="0"> 匹配成功 </a-select-option>
                  <a-select-option value="1"> 匹配失败 </a-select-option>
                  <a-select-option value="2"> 处理成功 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-button type="primary" @click="queryList" >查询</a-button>
              <a-button style="margin-left: 18px" @click="resetList" >重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!--表单内容-->
      <a-table
        size="middle"
        rowKey="id"
        :row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }"
        bordered
        :data-source="list"
        :columns="listColumns"
        :pagination="pagination"
        @change="pageChange"
      >
        <template slot="dxaction" slot-scope="text, record">
          <img
            @click="showpoint(record)"
            :src="require(`@/assets/collectionMappingSystem/seepoint.svg`)"
            title="点数据"
            style="margin-right: 8px; width: 18px; height: 18px; cursor: pointer"
          />
          <img
            @click="showline(record)"
            :src="require(`@/assets/collectionMappingSystem/seeline.svg`)"
            title="线数据"
            style="margin-right: 8px; width: 18px; height: 18px; cursor: pointer"
          />
          <img
            @click="showstatistics(record)"
            :src="require(`@/assets/collectionMappingSystem/seelinestatistics.svg`)"
            title="管线统计"
            style="width: 18px; height: 18px; cursor: pointer"
      
          />
        </template>
        <template slot="action" slot-scope="text, record">
          <img
            :src="require(`@/assets/collectionMappingSystem/tomap.svg`)"
            title="管线成图"
            style="margin-right: 8px; width: 18px; height: 18px; cursor: pointer"
            v-if="(record.matchStatus == 0 || record.matchStatus == 2) "
            @click="gxct(record.id)"
          />
          <img
            :src="require(`@/assets/collectionMappingSystem/errorCorrection.svg`)"
            style="margin-right: 8px; width: 18px; height: 18px; cursor: pointer"
            title="纠错"
            v-else-if="record.matchStatus == 1 "
            @click="getListMatching(record.id)"
         v-action:edit
          /> 
          <a-popconfirm
            title="确定要删除这条记录吗?"
            ok-text="确定"
            cancel-text="取消"
            @confirm="() => handleDelete(record.id)"
         v-action:del
          >
            <a-tooltip>
              <img  
                title="删除"
                :src="require(`@/assets/collectionMappingSystem/delete.svg`)"
                style="width: 18px; height: 18px; cursor: pointer"
              />
            </a-tooltip>
          </a-popconfirm>
          
        </template>
        <template slot="projectCategoryAction" slot-scope="text">
          <span v-if="text == 1">给水</span>
          <span v-else-if="text == 2">排水</span>
          <span v-else-if="text == 3">燃气</span>
          <span v-else-if="text == 4">热力</span>
        </template>
        <template slot="matchStatus" slot-scope="text, record">
          <span v-if="text == 0" style="color: #05db0d">匹配成功</span>
          <span v-if="text == 2" style="color: #05db0d">处理成功</span>
          <div
            v-else-if="text == 1"
            style="color: #f42626; display: flex; align-items: center; justify-content: center"
          >
            匹配失败
            <img
              @click="getListMatching(record.id)"
              src="@/assets/collectionMappingSystem/gth.png"
              style="width: 12px; height: 12px; margin-left: 2px; cursor: pointer"
        
            />
          </div>
        </template>
      </a-table>

      <!--项目匹配失败弹窗-->
      <a-modal
        :visible.sync="listFailedDialogVisible"
        @cancel="
          queryList()
          listFailedDialogVisible = false
        "
        :footer="null"
        :maskClosable="false"
        title="匹配失败"
        :wrapClassName="'correction-modal-right'"
      >
        <!-- 上半部分: 结果预览 -->
        <div class="table-box">
          <div class="table-title">结果预览</div>

          <a-table
            :dataSource="pipePointInfoPcList"
            :columns="previewColumns"
            :bordered="true"
            size="small"
            :scroll="{ y: 200 }"
            :pagination="false"
          />
          <!-- <div class="preview-header">
            <a-button type="primary" @click="handleWriteToDatabase" :disabled="pipePointInfoPcList.length === 0">
              写入数据库
            </a-button>
          </div> -->
        </div>

        <!-- 下半部分: (两个标签页) -->
        <div style="margin-top: 24px">
          <a-tabs defaultActiveKey="1" ref="correctionTabs">
            <!-- 缺少坐标 -->
            <a-tab-pane key="1" tab="缺少坐标">
              <div class="warning-box">
                <img src="@/assets/collectionMappingSystem/gth.png" class="warning-icon" />
                <div class="warning-text">以下管点没有找到对应的坐标</div>
              </div>

              <a-table
                :columns="missingCoordinatesColumns"
                :dataSource="coordinatesFailedList"
                :rowSelection="{
                  type: 'checkbox',
                  selectedRowKeys: selectedCorrectionPoints,
                  onChange: onCorrectionPointSelectionChange,
                  columnWidth: 60,
                }"
                :pagination="{
                  current: matchingPagination.current,
                  pageSize: matchingPagination.pageSize,
                  total: matchingPagination.total,
                  showTotal: (total) => `共 ${total} 条`,
                  showSizeChanger: true,
                  pageSizeOptions: ['10', '20', '50','100','200','500','1000'],                  onChange: handleMissingPageChange,
                  onShowSizeChange: handleMissingPageChange,
                }"
                :rowKey="(record, index) => index"
                :scroll="{ y: 250 }"
                class="points-table"
              >
                <template slot="intuitionPoint" slot-scope="text">
                  {{ text }}
                </template>
                <template slot="longitude" slot-scope="text, record">
                  <a-input-number
                    v-model="record.measurementLongitude"
                    :precision="6"
                    style="width: 150px"
                    placeholder="请输入经度"
                    @change="() => handleCorrectionCoordinateChange(record)"
                  />
                </template>
                <template slot="latitude" slot-scope="text, record">
                  <a-input-number
                    v-model="record.measurementLatitude"
                    :precision="6"
                    style="width: 150px"
                    placeholder="请输入纬度"
                    @change="() => handleCorrectionCoordinateChange(record)"
                  />
                </template>
                <template slot="groundHeight" slot-scope="text, record">
                  <a-input-number
                    v-model="record.groundElevation"
                    :precision="3"
                    style="width: 100px"
                    placeholder="请输入高程"
                    @change="() => handleCorrectionCoordinateChange(record)"
                  />
                </template>
              </a-table>

              <div class="button-container" style="margin-top: 16px">
                <div>
                  <a-button
                    type="danger"
                    @click="handleDeleteCorrectionSelected"
                    :disabled="!hasSelectedCorrectionPoints"
                    v-action:del
                  >
                    批量删除
                  </a-button>
                </div>
                <div>
                  <a-button
                    type="primary"
                    @click="handleCorrectionUseFuzzyCoordinates"
                    :disabled="!hasSelectedCorrectionPoints"
                    style="margin-right: 8px"
                    v-action:edit
                  >
                    使用模糊坐标
                  </a-button>
                  <a-button
                    type="primary"
                    @click="handleSaveCorrectionPoints"
                    style="margin-right: 8px"
                    :disabled="!hasSelectedCorrectionPoints"
                    v-action:add
                  >
                    保存
                  </a-button>
                </div>
              </div>
            </a-tab-pane>

            <!-- 物探点重复 -->
            <a-tab-pane key="2" tab="物探点重复">
              <div class="warning-box">
                <img src="@/assets/collectionMappingSystem/gth.png" class="warning-icon" />
                <div class="warning-text">以下物探点号重复</div>
              </div>
              <a-table
                :dataSource="pointDuplicateDataList"
                :columns="duplicatePointsColumns2"
                :pagination="{
                  current: correctionDuplicatePagination.current,
                  pageSize: correctionDuplicatePagination.pageSize,
                  total: correctionDuplicatePagination.total,
                  showTotal: (total) => `共 ${total} 条`,
                  showSizeChanger: true,
                  pageSizeOptions: ['10', '20', '50','100','200','500','1000'],                  onChange: handleCorrectionDuplicatePageChange,
                  onShowSizeChange: handleCorrectionDuplicatePageChange,
                }"
                :rowKey="(record, index) => index"
                :scroll="{ y: 250 }"
                :rowSelection="{
                  selectedRowKeys: selectedCorrectionDuplicatePoints,
                  onChange: onCorrectionDuplicatePointSelectionChange,
                  getCheckboxProps: getCorrectionDuplicateCheckboxProps,
                  hideSelectAll: true,
                  columnWidth: 60,
                }"
                :rowClassName="getCorrectionDuplicateRowClassName"
              >
                <template slot="intuitionPoint" slot-scope="text">
                  {{ text }}
                </template>
                <template slot="longitude" slot-scope="text, record">
                  <a-input-number
                    v-model="record.measurementLongitude"
                    :precision="6"
                    style="width: 120px"
                    placeholder="请输入经度"
                  />
                </template>
                <template slot="latitude" slot-scope="text, record">
                  <a-input-number
                    v-model="record.measurementLatitude"
                    :precision="6"
                    style="width: 120px"
                    placeholder="请输入纬度"
                  />
                </template>
                <template slot="groundHeight" slot-scope="text, record">
                  <a-input-number
                    v-model="record.groundElevation"
                    :precision="3"
                    style="width: 100px"
                    placeholder="请输入高程"
                  />
                </template>
                <template slot="action" slot-scope="text, record, index">
                  <a-radio
                    :checked="selectedCorrectionDuplicatePoints.includes(index)"
                    @change="() => handleUseCorrectionDuplicatePoint(record, index)"
                    :disabled="!checkPointComplete(record)"
                  >
                    使用
                  </a-radio>
                </template>
              </a-table>
              <div class="table-footer">
                <div class="button-group">
                  <a-button
                    type="primary"
                    @click="handleSaveCorrectionDuplicatePoints"
                    :disabled="!hasSelectedCorrectionDuplicatePoints"
                    v-action:add
                  >
                    保存
                  </a-button>
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </a-modal>
    </a-card>
    <!--点数据弹窗-->
    <a-modal :visible.sync="pointlistDialog" @cancel="pointlistDialog = false" width="70%" title="点数据">
      <a-form layout="inline" style="margin-bottom: 20px">
        <a-row :gutter="20">
          <a-col :md="6" :sm="12">
            <a-form-item label="物探点号:">
              <a-input :allowClear="true" v-model="pointForm.intuitionPoint" placeholder="物探点号"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12">
            <a-form-item label="是否收点:">
              <a-select
                placeholder="是否收点"
                :allowClear="true"
                style="width: 120px"
                v-model="pointForm.closingPoints"
              >
                <a-select-option :value="0">还未收点</a-select-option>
                <a-select-option :value="1">已经收点</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="是否已经完成坐标匹配:">
              <a-select
                placeholder="是否已经完成坐标匹配"
                :allowClear="true"
                style="width: 120px"
                v-model="pointForm.coordinatesMatch"
              >
                <a-select-option :value="0">还未完成</a-select-option>
                <a-select-option :value="1">已经完成</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="3" :sm="6" style="display: flex; align-items: center; height: 40px">
            <a-button type="primary" @click="getPointList">查询</a-button>
          </a-col>
        </a-row>
      </a-form>
      <div>
        <a-table
          size="middle"
          rowKey="id"
          bordered
          :data-source="pointList"
          :columns="pointListcolumns"
          :pagination="pointlistpage"
          @change="pointpageChange"
        >
          <template slot="closingPoints" slot-scope="text">
            <a-tag color="#C3C1E9" v-if="text == 0">还未收点</a-tag>
            <a-tag color="rgb(66, 211, 9)" v-else-if="text == 1">已经收点</a-tag>
          </template>
          <template slot="coordinatesMatch" slot-scope="text">
            <a-tag color="#C3C1E9" v-if="text == 0">还未完成</a-tag>
            <a-tag color="rgb(66, 211, 9)" v-else-if="text == 1">已经完成</a-tag>
          </template>
        </a-table>
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </a-modal>
    <!--线数据弹窗-->
    <a-modal :visible.sync="linelistDialog" @cancel="linelistDialog = false" width="70%" title="线数据">
      <a-form layout="inline" class="search-form" style="margin-bottom: 20px">
        <a-row :gutter="0" type="flex" align="middle">
          <a-col :md="6" :sm="12">
            <a-form-item label="连接点号">
              <a-input :allowClear="true" v-model="lineForm.connectionPointNumber" placeholder="请输入连接点号" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="被连接点号">
              <a-input :allowClear="true" v-model="lineForm.theDotNumberIsConnected" placeholder="请输入被连接点号" />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24" class="search-buttons">
            <a-button type="primary" @click="getLineList"> 查询 </a-button>
          </a-col>
        </a-row>
      </a-form>
      <div>
        <a-table
          size="middle"
          rowKey="id"
          bordered
          :data-source="lineList"
          :columns="lineListcolumns"
          :pagination="linelistpage"
          @change="linepageChange"
        >
          <template slot="flowDirection" slot-scope="text">
            <a-tag color="#C3C1E9" v-if="text == 1">连接点号 → 被连接点号</a-tag>
            <a-tag color="rgb(66, 211, 9)" v-else-if="text == 2">被连接点号 → 连接点号</a-tag>
          </template>
        </a-table>
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </a-modal>
    <!--统计弹窗-->
    <a-modal :visible.sync="statisticsDialog" @cancel="statisticsDialog = false" width="40%" title="管线统计">
      <div>
        <table class="tab" width="100%">
          <thead style="text-align: center; font-weight: bold">
            <tr>
              <th>管类</th>
              <th>类别</th>
              <th>数量</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(listItem, listIndex) in statisticsList">
              <!-- 渲染第一个数据项，并设置rowspan -->
              <tr :key="listIndex">
                <td align="center" :rowspan="listItem.data.length">
                  {{ listItem.tubeClassName || '--' }}
                </td>
                <td align="center">
                  {{ listItem.data[0].type }}
                </td>
                <td align="center">{{ listItem.data[0].value }}</td>
              </tr>
              <!-- 渲染剩余的数据项 -->
              <tr v-for="(item, itemIndex) in listItem.data.slice(1)" :key="`${listIndex}-${itemIndex}`">
                <td align="center">{{ item.type }}</td>
                <td align="center">{{ item.value }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </a-modal>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import mixinViewModule from '@/mixin/common'

const columns = [
  {
    title: '物探点号',
    dataIndex: 'intuitionPoint',
    align: 'center',
    width: 150,
  },
  {
    title: '经度',
    dataIndex: 'measurementLongitude',
    align: 'center',
  },
  {
    title: '纬度',
    dataIndex: 'measurementLatitude',
    align: 'center',
  },
  {
    title: '地面高程',
    width: 120,
    dataIndex: 'groundElevation',
    align: 'center',
  },
]

export default {
  name: 'CoordinateMatching',
  mixins: [mixinViewModule],
  components: {
    LoadingSpinner,
  },
  data() {
    return {
      // CoordinateMatching 部分数据
      file: { name: '' },
      columns,
      columns2: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '物探点号',
          dataIndex: 'intuitionPoint',
          align: 'center',
          width: 150,
        },
      ],
      columns3: [
        {
          title: '物探点号',
          dataIndex: 'intuitionPoint',
          align: 'center',
          width: 150,
        },
        {
          title: '经度',
          dataIndex: 'measurementLongitude',
          align: 'center',
          width: 160,
        },
        {
          title: '纬度',
          dataIndex: 'measurementLatitude',
          align: 'center',
          width: 160,
        },
        {
          title: '地面高程',
          dataIndex: 'groundElevation',
          align: 'center',
          width: 120,
        },
      ],
      PreviewResultsDigital: false,
      coordinateDialogVisible: false,
      phone: '',
      projectid: '',
      userlist: [],
      dblist: [],
      dataSource: [],
      matchSucceededList: [],
      matchFailedList: [],
      queryuserUrl: '/gis-manager/user/deploy/user/list',
      submitting: false,
      loadingSpinnerSuccess: false,
      repeatList: [],
      // CoordinateMatchingList 部分数据
      listFailedDialogVisible: false,
      listMatchFailedList: [],
      queryUrl: '/gis-manager/diagramming/project/page?isPicture=0',
      list: [],
      selectedRows: [],
      listColumns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 70,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '用户名称',
          dataIndex: 'userName',
          align: 'center',
        },
        {
          title: '手机号码',
          dataIndex: 'phone',
          align: 'center',
        },
        {
          title: '采集项目名称',
          dataIndex: 'projectName',
          align: 'center',
        },
        {
          title: '采集项目类型',
          dataIndex: 'projectCategory',
          align: 'center',
          scopedSlots: { customRender: 'projectCategoryAction' },
        },
        {
          title: '采集单位',
          dataIndex: 'acquisitionUnits',
          align: 'center',
        },
        {
          title: '作业小组',
          dataIndex: 'assignmentGroup',
          align: 'center',
        },
        {
          title: '负责人',
          dataIndex: 'responsiblePerson',
          align: 'center',
        },
        {
          title: '匹配时间',
          dataIndex: 'matchingTime',
          align: 'center',
        },
        {
          title: '匹配状态',
          dataIndex: 'matchStatus',
          align: 'center',
          scopedSlots: { customRender: 'matchStatus' },
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          align: 'center',
        },
        {
          title: '详情',
          key: 'dxaction',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'dxaction' },
        },
        {
          title: '操作',
          key: 'action',
          width: 130,
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      query: {
        phone: undefined,
        projectName: '',
        matchStatus: undefined,
      },
      userOptions: [],
      needQuery: false, // 覆盖mixin中的默认行为
      missingCoordinatesColumns: [
        {
          title: '物探点号',
          dataIndex: 'intuitionPoint',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'intuitionPoint' },
        },
        {
          title: '经度',
          dataIndex: 'measurementLongitude',
          align: 'center',
          width: 160,
          scopedSlots: { customRender: 'longitude' },
        },
        {
          title: '纬度',
          dataIndex: 'measurementLatitude',
          align: 'center',
          width: 160,
          scopedSlots: { customRender: 'latitude' },
        },
        {
          title: '地面高程',
          dataIndex: 'groundElevation',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'groundHeight' },
        },
      ],
      selectedPoints: [],
      hasSelectedPoints: false,
      duplicatePointsColumns: [
        {
          title: '物探点号',
          dataIndex: 'intuitionPoint',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'intuitionPoint' },
        },
        {
          title: '经度',
          dataIndex: 'measurementLongitude',
          align: 'center',
          width: 160,
          scopedSlots: { customRender: 'longitude' },
        },
        {
          title: '纬度',
          dataIndex: 'measurementLatitude',
          align: 'center',
          width: 160,
          scopedSlots: { customRender: 'latitude' },
        },
        {
          title: '地面高程',
          dataIndex: 'groundElevation',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'groundHeight' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'action' },
        },
      ],
      duplicatePointsColumns2: [
        {
          title: '物探点号',
          dataIndex: 'intuitionPoint',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'intuitionPoint' },
        },
        {
          title: '经度',
          dataIndex: 'measurementLongitude',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'longitude' },
        },
        {
          title: '纬度',
          dataIndex: 'measurementLatitude',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'latitude' },
        },
        {
          title: '地面高程',
          dataIndex: 'groundElevation',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'groundHeight' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 80,
          scopedSlots: { customRender: 'action' },
        },
      ],
      selectedDuplicatePoints: [],
      hasSelectedDuplicatePoints: false,
      selectedMissingPoints: [],
      hasSelectedMissingPoints: false,
      // 用于纠错弹窗的数据
      selectedCorrectionPoints: [],
      hasSelectedCorrectionPoints: false,
      pipePointInfoPcList: [],
      coordinatesFailedList: [],
      pointDuplicateDataList: [],
      previewColumns: [
        {
          title: '物探点号',
          dataIndex: 'intuitionPoint',
          align: 'center',
          width: 150,
        },
        {
          title: '经度',
          dataIndex: 'measurementLongitude',
          align: 'center',
          width: 160,
        },
        {
          title: '纬度',
          dataIndex: 'measurementLatitude',
          align: 'center',
          width: 160,
        },
        {
          title: '地面高程',
          dataIndex: 'groundElevation',
          align: 'center',
          width: 120,
        },
      ],
      selectedCorrectionDuplicatePoints: [],
      hasSelectedCorrectionDuplicatePoints: false,
      // 匹配结果说明分页数据
      matchingPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      duplicatePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      // 纠错弹窗分页数据
      correctionDuplicatePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },

      // //点线详情
      pointlistpage: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '50'],
      },
      pointupdatedata: '',
      pointupdatefrom: this.$form.createForm(this),
      pointlistDialog: false,
      pointupdateDialog: false,
      pointForm: {
        coordinatesMatch: '',
        closingPoints: '',
        intuitionPoint: '',
      },
      pointList: [],
      pointListcolumns: [
        {
          title: '物探点号',
          dataIndex: 'intuitionPoint',
        },
        {
          title: '模糊经度',
          dataIndex: 'obscureLongitude',
        },
        {
          title: '模糊纬度',
          dataIndex: 'obscureLatitude',
        },
        {
          title: '测量经度',
          dataIndex: 'measurementLongitude',
        },
        {
          title: '测量纬度',
          dataIndex: 'measurementLatitude',
        },
        {
          title: '地面高程',
          dataIndex: 'groundElevation',
        },
        {
          title: '管类名称',
          dataIndex: 'tubeClassName',
        },
        {
          title: '管类代码',
          dataIndex: 'tubeClassCode',
        },
        {
          title: '是否收点',
          dataIndex: 'closingPoints',
          scopedSlots: { customRender: 'closingPoints' },
        },
        {
          title: '坐标匹配',
          dataIndex: 'coordinatesMatch',
          scopedSlots: { customRender: 'coordinatesMatch' },
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
        },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   width: 100,
        //   scopedSlots: { customRender: 'action' }
        // }
      ],

      linelistpage: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      },
      linelistDialog: false,
      lineList: [],
      lineListcolumns: [
        {
          title: '连接点号',
          dataIndex: 'connectionPointNumber',
        },
        {
          title: '被连接点号',
          dataIndex: 'theDotNumberIsConnected',
        },
        {
          title: '流向',
          dataIndex: 'flowDirection',
          scopedSlots: { customRender: 'flowDirection' },
        },
        {
          title: '管线长度',
          dataIndex: 'pipelineLength',
        },
        {
          title: '管类代码',
          dataIndex: 'tubeClassCode',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
        },
      ],
      lineForm: {
        connectionPointNumber: '',
        theDotNumberIsConnected: '',
      },
      statisticsList: [],
      statisticsDialog: false,
    }
  },
  created() {
    this.getUserlist()
    this.getUserList()
    this.queryList()
    // 为repeatList添加索引，方便处理
    this.repeatList = this.repeatList.map((item, index) => ({
      ...item,
      _index: index,
    }))
  },
  mounted() {
    // 确保表格选择状态正确初始化
    this.$nextTick(() => {
      if (this.missingPointsRowSelection) {
        this.missingPointsRowSelection.selectedRowKeys = this.selectedMissingPoints
      }
    })
  },
  methods: {
    // CoordinateMatching 方法
    getUserlist() {
      this.$http.get(this.queryuserUrl).then((res) => {
        this.userlist = res.data
      })
    },
    getdblist() {
      if (!this.phone) return

      // 重置DB文件选择
      this.projectid = ''
      // 重置坐标文件相关数据
      this.dataSource = []
      this.PreviewResultsDigital = false
      this.issubmit = false
      this.coordinateDialogVisible = false
      this.matchFailedList = []
      // 重置坐标文件选择
      this.file = {
        name: '',
        content: null,
      }

      this.$http.get('/gis-manager/pipeline/project/list?phone=' + this.phone).then((res) => {
        this.dblist = res.data
      })
    },
    getmatching() {
      if (!this.projectid || !this.file.name) {
        this.$message.error('请选择以上文件！')
        return
      }
      this.submitting = true
      const formData = new FormData()
      formData.append('file', this.file)

      this.$http
        .post('/gis-manager/pipeline/point/file/matching/' + this.projectid, formData)
        .then((res) => {
          if (res.code === 0) {
            this.loadingSpinnerSuccess = true
            setTimeout(() => {
              this.loadingSpinnerSuccess = false
              this.submitting = false
              this.PreviewResultsDigital = true
            }, 500)
            let data = res.data
            this.dataSource = data.txtFileList
            this.matchSucceededList = data.matchSucceededList
            this.matchFailedList = data.matchFailedList
            this.repeatList = data.repeatList || []

            // 初始化选择状态
            this.selectedMissingPoints = []
            this.selectedDuplicatePoints = []
            this.hasSelectedMissingPoints = false
            this.hasSelectedDuplicatePoints = false

            // 为repeatList添加索引
            this.repeatList = this.repeatList.map((item, index) => ({
              ...item,
              _index: index,
            }))
          } else {
            this.$message.error(res.message || '匹配失败')
          }
        })
        .catch((error) => {
          console.error('匹配失败:', error)
          this.$message.error('匹配失败')
        })
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'text/plain'
      if (!isJpgOrPng) {
        this.$message.error('只能选择txt格式')
        this.file = {}
        return false
      }
      this.file = file
      return false
    },

    //写入数据库
    handleOk() {
      this.submitting = true
      // 过滤出coordinatesMatch为0的数据
      const filteredRepeatList = this.repeatList.filter((item) => item.coordinatesMatch === 0)

      this.$http
        .post('/gis-manager/pipeline/point/update/list', {
          matchSucceededList: this.matchSucceededList,
          matchFailedList: this.matchFailedList,
          repeatList: filteredRepeatList,
        })
        .then((res) => {
          if (res.code === 0) {
            this.PreviewResultsDigital = false
            this.loadingSpinnerSuccess = true
            setTimeout(() => {
              this.loadingSpinnerSuccess = false
              this.submitting = false
              this.queryList() // 更新列表
            }, 1000)
          } else {
            this.$message.error(res.message || '写入失败')
            this.submitting = false
          }
        })
        .catch((error) => {
          console.error('写入数据失败:', error)
          this.$message.error('写入数据失败')
          this.submitting = false
        })
    },
    handleCancel() {
      if (this.coordinateDialogVisible) {
        this.coordinateDialogVisible = false
      }

      // 清空选择状态
      this.handleClearSelections()
    },

    // CoordinateMatchingList 方法
    async getUserList() {
      try {
        const res = await this.$http.get('/gis-manager/user/deploy/user/list/0')
        if (res.code === 0) {
          this.userOptions = res.data || []
        } else {
          this.$message.error(res.message || '获取用户列表失败')
        }
      } catch (error) {
        console.error('获取用户列表失败:', error)
        this.$message.error('获取用户列表失败')
      }
    },
    filterUserOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleUserChange(value) {
      this.query.phone = value
      this.queryList()
    },
    async gxct(currentProjectId) {
      try {
        // 1. 先等待接口请求完成
        const res = await this.$http.get('/gis-manager/diagramming/project/pipeline/' + currentProjectId)
        // 2. 接口请求成功后，再跳转页面
        const routeUrl = this.$router.resolve({
          path: '/gather-mapping/PipelineMapping',
          query: {
            currentProjectId: currentProjectId,
          },
        })
        window.open(routeUrl.href, '_blank')
      } catch (error) {
        console.error('获取管线数据失败:', error)
        // 可以在这里处理错误，比如提示用户
      }
    },
    // 查询纠错信息
    getListMatching(id) {
      this.submitting = true
      this.projectid = id // 保留赋值但不显示在页面上

      // 重置分页数据
      this.correctionDuplicatePagination = {
        current: 1,
        pageSize: 10,
        total: 0,
      }

      this.$http
        .get('/gis-manager/diagramming/point/error/correction/' + id)
        .then((res) => {
          if (res.code === 0 && res.data) {
            this.loadingSpinnerSuccess = true
            setTimeout(() => {
              this.loadingSpinnerSuccess = false
              this.submitting = false
            }, 1000)
            // 处理返回数据
            this.pipePointInfoPcList = res.data.pipePointInfoPcList || []
            this.coordinatesFailedList = res.data.coordinatesFailedList || []

            // 获取物探点重复列表
            this.fetchCorrectionDuplicatePoints(id)

            // 保持原有数据兼容 - 缺少坐标的点列表
            this.listMatchFailedList = this.coordinatesFailedList

            // 重置选择状态
            this.selectedCorrectionPoints = []
            this.hasSelectedCorrectionPoints = false

            // 显示弹窗
            this.listFailedDialogVisible = true

            // 获取缺少坐标的点列表 - 修改dataSource为2
            this.$http
              .get('/gis-manager/diagramming/matching/page', {
                params: {
                  dataSource: 2, // 修改为2
                  page: 1,
                  limit: 10,
                  projectManagementId: id,
                },
              })
              .then((res) => {
                if (res.code === 0) {
                  this.coordinatesFailedList = res.data.list || []
                  this.matchingPagination.total = Number(res.data.total) || 0

                  // 更新选中状态
                  this.selectedCorrectionPoints = []
                  this.hasSelectedCorrectionPoints = false
                } else {
                  this.$message.error(res.message || '获取缺少坐标数据失败')
                }
              })
              .catch((error) => {
                console.error('获取缺少坐标数据失败:', error)
                this.$message.error('获取缺少坐标数据失败')
              })
          } else {
            this.$message.error(res.message || '获取纠错信息失败')
          }
        })
        .catch((error) => {
          console.error('获取纠错信息失败:', error)
          this.$message.error('获取纠错信息失败')
        })
    },
    // 缺少坐标标签页 - 点选择变更
    onPointSelectionChange(selectedRowKeys) {
      console.log('Missing points selection changed:', selectedRowKeys)
      this.selectedMissingPoints = selectedRowKeys
      this.hasSelectedMissingPoints = selectedRowKeys.length > 0
    },
    // 纠错弹窗方法 - 选择变更
    onCorrectionPointSelectionChange(selectedRowKeys) {
      console.log('Correction points selection changed:', selectedRowKeys)
      this.selectedCorrectionPoints = selectedRowKeys
      this.hasSelectedCorrectionPoints = selectedRowKeys.length > 0
    },
    // 缺少坐标标签页 - 坐标变更
    handleCoordinateChange(record) {
      // 检查是否所有必填字段都已填写
      const recordIndex = this.matchFailedList.findIndex((item) => item === record)
      if (recordIndex === -1) return

      if (this.checkPointComplete(record)) {
        // 如果所有字段都已填写，自动选中该行
        if (!this.selectedMissingPoints.includes(recordIndex)) {
          this.selectedMissingPoints = [...this.selectedMissingPoints, recordIndex]
          this.hasSelectedMissingPoints = this.selectedMissingPoints.length > 0
        }
      } else {
        // 如果有字段为空，取消选中该行
        this.selectedMissingPoints = this.selectedMissingPoints.filter((index) => index !== recordIndex)
        this.hasSelectedMissingPoints = this.selectedMissingPoints.length > 0
      }
    },
    handleDeletePoint(record) {
      const recordIndex = this.matchFailedList.findIndex((item) => item === record)
      if (recordIndex !== -1) {
        // 如果删除的点在已选中的点中，也要移除
        this.selectedMissingPoints = this.selectedMissingPoints.filter((index) => index !== recordIndex)
        this.hasSelectedMissingPoints = this.selectedMissingPoints.length > 0

        // 从matchFailedList中移除该点
        this.matchFailedList = this.matchFailedList.filter((_, index) => index !== recordIndex)

        // 从matchSucceededList中也移除该点
        this.matchSucceededList = this.matchSucceededList.filter(
          (item) => item.intuitionPoint !== record.intuitionPoint
        )
      }
    },
    handleSavePoints() {
      if (this.matchFailedList.length == 0 && this.repeatList.length == 0) {
        this.coordinateDialogVisible = false
        return
      }

      // 获取选中的点并预处理数据
      const selectedPoints = this.selectedMissingPoints.map((index) => {
        const point = { ...this.matchFailedList[index] }
        // 确保 groundElevation 为有效值
        if (point.groundElevation === '') {
          point.groundElevation = null
        }
        return point
      })

      // 验证选中的点是否都填写完整
      const invalidPoints = selectedPoints.filter((point) => !this.checkPointComplete(point))

      if (invalidPoints.length > 0) {
        this.$message.error('选中的点必须填写完整所有坐标信息')
        return
      }

      // 获取选中点的ID
      const selectedIds = this.selectedMissingPoints.map((index) => this.matchFailedList[index].id)

      // 调用批量删除接口
      this.$http
        .post('/gis-manager/diagramming/matching/batch/remove', {
          dataSource: 1,
          ids: selectedIds,
          projectManagementId: this.projectid,
        })
        .then((res) => {
          if (res.code === 0) {
            // 更新matchSucceededList
            selectedPoints.forEach((point) => {
              const existingIndex = this.matchSucceededList.findIndex((p) => p.intuitionPoint === point.intuitionPoint)

              if (existingIndex !== -1) {
                this.matchSucceededList[existingIndex] = {
                  ...this.matchSucceededList[existingIndex],
                  measurementLongitude: point.measurementLongitude,
                  measurementLatitude: point.measurementLatitude,
                  groundElevation: point.groundElevation,
                  coordinatesMatch: 1,
                }
              }
            })

            // 从matchFailedList中移除已保存的点
            this.matchFailedList = this.matchFailedList.filter(
              (_, index) => !this.selectedMissingPoints.includes(index)
            )

            // 清空选择
            this.selectedMissingPoints = []
            if (this.missingPointsRowSelection) {
              this.missingPointsRowSelection.selectedKeys = []
            }
            this.hasSelectedMissingPoints = false

            // 重新获取列表数据
            this.fetchMissingCoordinates()

            this.$message.success('保存成功')
          } else {
            this.$message.error(res.message || '保存失败')
          }
        })
        .catch((error) => {
          console.error('保存失败:', error)
          this.$message.error('保存失败')
        })
    },
    // 检查点是否所有必填字段都已填写
    checkPointComplete(record) {
      return (
        record.intuitionPoint &&
        record.measurementLongitude &&
        record.measurementLatitude &&
        record.groundElevation !== undefined &&
        record.groundElevation !== null
      )
    },
    // 获取复选框属性
    getCheckboxProps(record, index) {
      // 如果记录不完整，禁用复选框
      if (!this.checkPointComplete(record)) {
        return {
          props: {
            disabled: true,
            checked: false,
          },
        }
      }

      // 检查是否有相同物探点号的记录已被选中
      const hasSamePointSelected = this.selectedDuplicatePoints.some((key) => {
        const selectedRecord = this.repeatList[key]
        return selectedRecord && selectedRecord.intuitionPoint === record.intuitionPoint && key !== index
      })

      return {
        props: {
          disabled: hasSamePointSelected,
          checked: this.selectedDuplicatePoints.includes(index),
        },
      }
    },
    onDuplicatePointSelectionChange(selectedKeys) {
      // 获取新增的选中项
      const newlySelected = selectedKeys.filter((key) => !this.selectedDuplicatePoints.includes(key))

      // 如果有新增选中项
      if (newlySelected.length > 0) {
        const finalSelectedKeys = [...this.selectedDuplicatePoints]

        // 对每个新选中的项
        newlySelected.forEach((newKey) => {
          const newRecord = this.repeatList[newKey]
          if (!newRecord) return

          // 移除已选中的相同物探点号的记录
          const samePointKeys = finalSelectedKeys.filter((oldKey) => {
            const oldRecord = this.repeatList[oldKey]
            return oldRecord && oldRecord.intuitionPoint === newRecord.intuitionPoint
          })

          // 从已选中项中移除相同物探点号的记录
          samePointKeys.forEach((key) => {
            const index = finalSelectedKeys.indexOf(key)
            if (index > -1) {
              finalSelectedKeys.splice(index, 1)
            }
          })

          // 添加新选中的项
          finalSelectedKeys.push(newKey)
        })

        // 更新选中状态
        this.selectedDuplicatePoints = finalSelectedKeys
      } else {
        // 如果是取消选中，直接更新
        this.selectedDuplicatePoints = selectedKeys
      }

      this.hasSelectedDuplicatePoints = this.selectedDuplicatePoints.length > 0
    },
    handleDuplicateCoordinateChange(record) {
      // 检查是否所有必填字段都已填写
      const recordIndex = this.repeatList.findIndex((item) => item === record)
      if (recordIndex === -1) return

      if (this.checkPointComplete(record)) {
        // 如果所有字段都已填写，允许选择此行
        this.canUseDuplicatePoint(record, recordIndex)
      }
    },
    getDuplicateRowClassName(record, index) {
      // 如果该行被选中，添加高亮类名
      if (this.selectedDuplicatePoints.includes(index)) {
        return 'selected-row'
      }
      return ''
    },

    // 检查重复点记录属性
    getDuplicateCheckboxProps(record, index) {
      // 如果记录不完整，禁用复选框
      if (!this.checkPointComplete(record)) {
        return {
          props: {
            disabled: true,
            checked: false,
          },
        }
      }

      // 检查是否有相同物探点号的记录已被选中
      const hasSamePointSelected = this.selectedDuplicatePoints.some((key) => {
        const selectedRecord = this.repeatList[key]
        return selectedRecord && selectedRecord.intuitionPoint === record.intuitionPoint && key !== index
      })

      return {
        props: {
          disabled: hasSamePointSelected,
          checked: this.selectedDuplicatePoints.includes(index),
        },
      }
    },

    // 检查是否可以使用该点
    canUseDuplicatePoint(record, index) {
      return this.checkPointComplete(record)
    },

    // 处理使用重复点
    handleUseDuplicatePoint(record, index) {
      if (!this.canUseDuplicatePoint(record, index)) {
        this.$message.warning('请先填写完整坐标信息')
        return
      }

      // 获取物探点号
      const pointName = record.intuitionPoint

      // 清除同一物探点号的其他选中项
      this.selectedDuplicatePoints = this.selectedDuplicatePoints.filter((key) => {
        const selectedRecord = this.repeatList[key]
        return !selectedRecord || selectedRecord.intuitionPoint !== pointName
      })

      // 选中当前项
      if (!this.selectedDuplicatePoints.includes(index)) {
        this.selectedDuplicatePoints.push(index)
        this.hasSelectedDuplicatePoints = true
      }

      this.$message.success(`已选择物探点 ${pointName} 的坐标`)
    },

    // 保存重复点选择
    handleSaveDuplicatePoints() {
      if (this.matchFailedList.length == 0 && this.repeatList.length == 0) {
        this.coordinateDialogVisible = false
        return
      }

      // 获取选中的点并预处理数据
      const selectedPoints = this.selectedDuplicatePoints.map((index) => {
        const point = { ...this.repeatList[index] }
        // 确保 groundElevation 为有效值
        if (point.groundElevation === '') {
          point.groundElevation = null
        }
        return point
      })

      // 验证选中的点是否都填写完整
      const invalidPoints = selectedPoints.filter((point) => !this.checkPointComplete(point))
      if (invalidPoints.length > 0) {
        this.$message.error('选中的点必须填写完整所有坐标信息')
        return
      }

      // 获取选中点和相同物探点号的点的ID
      const selectedIds = []
      const selectedPointNames = new Set(selectedPoints.map((point) => point.intuitionPoint))

      this.repeatList.forEach((point, index) => {
        if (selectedPointNames.has(point.intuitionPoint)) {
          selectedIds.push(point.id)
        }
      })

      // 调用批量删除接口
      this.$http
        .post('/gis-manager/diagramming/duplicate/batch/remove', {
          dataSource: 1,
          ids: selectedIds,
          projectManagementId: this.projectid,
        })
        .then((res) => {
          if (res.code === 0) {
            // 更新repeatList中的状态
            const uniquePoints = new Map()
            selectedPoints.forEach((point) => {
              uniquePoints.set(point.intuitionPoint, true)
            })

            // 更新repeatList
            this.repeatList = this.repeatList.map((point) => {
              const isSelected = uniquePoints.get(point.intuitionPoint)
              return {
                ...point,
                coordinatesMatch: isSelected ? 1 : 0,
              }
            })

            // 更新matchSucceededList中的点
            selectedPoints.forEach((point) => {
              const existingIndex = this.matchSucceededList.findIndex((p) => p.intuitionPoint === point.intuitionPoint)
              if (existingIndex !== -1) {
                // 如果找到相同物探点号的点，更新其坐标信息
                this.matchSucceededList[existingIndex] = {
                  ...this.matchSucceededList[existingIndex],
                  measurementLongitude: point.measurementLongitude,
                  measurementLatitude: point.measurementLatitude,
                  groundElevation: point.groundElevation,
                  coordinatesMatch: 1,
                }
              } else {
                // 如果没有找到，添加到matchSucceededList
                this.matchSucceededList.push({
                  ...point,
                  coordinatesMatch: 1,
                })
              }
            })

            // 清空选中状态
            this.selectedDuplicatePoints = []
            this.hasSelectedDuplicatePoints = false

            this.$message.success('保存成功')

            // 重新获取列表数据
            this.fetchDuplicatePoints()

            // 关闭弹窗
            this.coordinateDialogVisible = false
          } else {
            this.$message.error(res.message || '保存失败')
          }
        })
        .catch((error) => {
          console.error('保存失败:', error)
          this.$message.error('保存失败')
        })
    },
    handleDeleteSelected() {
      if (!this.selectedMissingPoints.length) {
        this.$message.warning('请选择要删除的点')
        return
      }

      this.$confirm({
        title: '确认删除',
        content: `确定要删除选中的 ${this.selectedMissingPoints.length} 个点吗？`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          // 获取选中点的ID
          const selectedIds = this.selectedMissingPoints.map((index) => this.matchFailedList[index].id)

          // 获取选中点的物探点号,用于从matchSucceededList中删除相同物探点号的数据
          const selectedIntuitionPoints = this.selectedMissingPoints.map(
            (index) => this.matchFailedList[index].intuitionPoint
          )

          // 调用批量删除接口
          this.$http
            .post('/gis-manager/diagramming/matching/batch/remove', {
              dataSource: 1,
              ids: selectedIds,
              projectManagementId: this.projectid,
            })
            .then((res) => {
              if (res.code === 0) {
                // 从matchFailedList中移除选中的点
                this.matchFailedList = this.matchFailedList.filter(
                  (_, index) => !this.selectedMissingPoints.includes(index)
                )

                // 从matchSucceededList中移除相同物探点号的数据
                this.matchSucceededList = this.matchSucceededList.filter(
                  (item) => !selectedIntuitionPoints.includes(item.intuitionPoint)
                )

                // 重置选择状态
                this.selectedMissingPoints = []
                this.hasSelectedMissingPoints = false

                this.$message.success('删除成功')

                // 重新获取列表数据
                this.fetchMissingCoordinates()
              } else {
                this.$message.error(res.message || '删除失败')
              }
            })
            .catch((error) => {
              console.error('删除失败:', error)
              this.$message.error('删除失败')
            })
        },
      })
    },
    showMatchingResults() {
      // 显示匹配结果说明弹窗
      this.coordinateDialogVisible = true

      // 重置分页数据
      this.matchingPagination = {
        current: 1,
        pageSize: 10,
        total: 0,
      }
      this.duplicatePagination = {
        current: 1,
        pageSize: 10,
        total: 0,
      }

      // 获取缺少坐标的点列表
      this.fetchMissingCoordinates()

      // 获取物探点重复列表
      this.fetchDuplicatePoints()
    },

    // 获取缺少坐标的点列表
    fetchMissingCoordinates() {
      this.submitting = true
      this.$http
        .get('/gis-manager/diagramming/matching/page', {
          params: {
            dataSource: 1,
            page: this.matchingPagination.current,
            limit: this.matchingPagination.pageSize,
            projectManagementId: this.projectid,
          },
        })
        .then((res) => {
          if (res.code === 0) {
            this.matchFailedList = res.data.list || []
            this.matchingPagination.total = Number(res.data.total) || 0

            // 更新选中状态
            this.selectedMissingPoints = []
            this.hasSelectedMissingPoints = false
            this.updateSelection()
          } else {
            this.$message.error(res.message || '获取缺少坐标数据失败')
          }
          this.submitting = false
        })
        .catch((error) => {
          console.error('获取缺少坐标数据失败:', error)
          this.$message.error('获取缺少坐标数据失败')
          this.submitting = false
        })
    },

    // 获取物探点重复列表
    fetchDuplicatePoints() {
      this.submitting = true
      this.$http
        .get('/gis-manager/diagramming/duplicate/page', {
          params: {
            dataSource: 1,
            page: this.duplicatePagination.current,
            limit: this.duplicatePagination.pageSize,
            projectManagementId: this.projectid,
          },
        })
        .then((res) => {
          if (res.code === 0) {
            this.repeatList = res.data.list || []
            this.duplicatePagination.total = Number(res.data.total) || 0

            // 为repeatList添加索引
            this.repeatList = this.repeatList.map((item, index) => ({
              ...item,
              _index: index,
            }))

            // 更新选中状态
            this.selectedDuplicatePoints = []
            this.hasSelectedDuplicatePoints = false
          } else {
            this.$message.error(res.message || '获取物探点重复数据失败')
          }
          this.submitting = false
        })
        .catch((error) => {
          console.error('获取物探点重复数据失败:', error)
          this.$message.error('获取物探点重复数据失败')
          this.submitting = false
        })
    },

    // 缺少坐标分页变化处理
    handleMissingPageChange(page, pageSize) {
      // 如果是从列表进入的纠错弹窗,使用 dataSource: 2
      if (this.listFailedDialogVisible) {
        this.matchingPagination.current = page
        this.matchingPagination.pageSize = pageSize

        // 获取缺少坐标的点列表
        this.$http
          .get('/gis-manager/diagramming/matching/page', {
            params: {
              dataSource: 2, // 从列表进入时使用 2
              page: page,
              limit: pageSize,
              projectManagementId: this.projectid,
            },
          })
          .then((res) => {
            if (res.code === 0) {
              this.coordinatesFailedList = res.data.list || []
              this.matchingPagination.total = Number(res.data.total) || 0
            }
          })
      } else {
        // 直接操作时使用原来的方法
        this.matchingPagination.current = page
        this.matchingPagination.pageSize = pageSize
        this.fetchMissingCoordinates()
      }
    },

    // 物探点重复分页变化处理
    handleDuplicatePageChange(pagination) {
      this.duplicatePagination.current = pagination.current
      this.fetchDuplicatePoints()
    },

    updateSelection() {
      // 更新选中状态
      this.$nextTick(() => {
        if (this.matchFailedList && this.matchFailedList.length > 0) {
          // 找出所有填写完整的点的索引
          const completePoints = this.matchFailedList
            .map((item, index) => ({ item, index }))
            .filter(({ item }) => this.checkPointComplete(item))
            .map(({ index }) => index)

          // 更新选中状态
          this.selectedMissingPoints = completePoints
          this.hasSelectedMissingPoints = completePoints.length > 0
          console.log('Auto selected complete points:', this.selectedMissingPoints)
        }
      })
    },
    handleClearSelections() {
      // 清空所有选择状态
      this.selectedMissingPoints = []
      this.selectedDuplicatePoints = []
      this.hasSelectedMissingPoints = false
      this.hasSelectedDuplicatePoints = false
    },
    handleUseFuzzyCoordinates() {
      if (!this.selectedMissingPoints.length) {
        this.$message.warning('请选择要使用模糊坐标的点')
        return
      }

      // 获取选中的点的物探点号
      const selectedPoints = this.selectedMissingPoints.map((index) => ({
        intuitionPoint: this.matchFailedList[index].intuitionPoint,
      }))

      // 调用模糊坐标接口
      this.$http
        .post('/gis-manager/diagramming/point/fuzzy/coordinates', {
          queryMethod: 1, //1.写入数据库前查询，2.写入数据库后查询
          pipePointList: selectedPoints,
          projectManagementId: this.projectid,
        })
        .then((res) => {
          if (res.code === 0 && res.data && res.data.pipePointList) {
            // 更新选中点的坐标信息
            const fuzzyPoints = new Map(res.data.pipePointList.map((point) => [point.intuitionPoint, point]))

            this.matchFailedList = this.matchFailedList.map((point, index) => {
              if (this.selectedMissingPoints.includes(index)) {
                const fuzzyPoint = fuzzyPoints.get(point.intuitionPoint)
                if (fuzzyPoint) {
                  return {
                    ...point,
                    measurementLongitude: fuzzyPoint.measurementLongitude,
                    measurementLatitude: fuzzyPoint.measurementLatitude,
                    groundElevation: fuzzyPoint.groundElevation,
                  }
                }
              }
              return point
            })

            this.$message.success('模糊坐标应用成功')
          } else {
            this.$message.error(res.message || '获取模糊坐标失败')
          }
        })
        .catch((error) => {
          console.error('获取模糊坐标失败:', error)
          this.$message.error('获取模糊坐标失败')
        })
    },
    // 纠错弹窗方法 - 坐标变更
    handleCorrectionCoordinateChange(record) {
      // 检查是否所有必填字段都已填写
      const recordIndex = this.coordinatesFailedList.findIndex((item) => item === record)
      if (recordIndex === -1) return

      if (this.checkPointComplete(record)) {
        // 如果所有字段都已填写，自动选中该行
        if (!this.selectedCorrectionPoints.includes(recordIndex)) {
          this.selectedCorrectionPoints = [...this.selectedCorrectionPoints, recordIndex]
          this.hasSelectedCorrectionPoints = this.selectedCorrectionPoints.length > 0
        }
      } else {
        // 如果有字段为空，取消选中该行
        this.selectedCorrectionPoints = this.selectedCorrectionPoints.filter((index) => index !== recordIndex)
        this.hasSelectedCorrectionPoints = this.selectedCorrectionPoints.length > 0
      }
    },
    // 纠错弹窗方法 - 批量删除
    handleDeleteCorrectionSelected() {
      if (!this.selectedCorrectionPoints.length) {
        this.$message.warning('请选择要删除的点')
        return
      }

      this.$confirm({
        title: '确认删除',
        content: `确定要删除选中的 ${this.selectedCorrectionPoints.length} 个点吗？`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          // 获取选中点的物探点号
          const selectedIntuitionPoints = this.selectedCorrectionPoints.map(
            (index) => this.coordinatesFailedList[index].intuitionPoint
          )

          // 从pipePointInfoPcList中移除相同物探点号的数据
          this.pipePointInfoPcList = this.pipePointInfoPcList.filter(
            (item) => !selectedIntuitionPoints.includes(item.intuitionPoint)
          )

          // 获取选中的点数据
          const selectedPoints = this.selectedCorrectionPoints.map((index) => this.coordinatesFailedList[index])

          // 调用统一的更新接口
          this.$http
            .post('/gis-manager/diagramming/point/update/fuzzy/coordinates', {
              projectManagementId: this.projectid,
              pipePointInfoPcList: this.pipePointInfoPcList,
              // 传递选中的点数据
              coordinatesFailedList: selectedPoints,
              pointDuplicateDataList: this.pointDuplicateDataList,
            })
            .then((res) => {
              if (res.code === 0) {
                // 更新列表数据
                this.coordinatesFailedList = this.coordinatesFailedList.filter(
                  (_, index) => !this.selectedCorrectionPoints.includes(index)
                )

                // 重置选择状态
                this.selectedCorrectionPoints = []
                this.hasSelectedCorrectionPoints = false

                // 如果当前页没有数据了，跳转到第一页
                if (this.coordinatesFailedList.length === 0) {
                  this.matchingPagination.current = 1
                  // 重新获取第一页数据
                  this.$http
                    .get('/gis-manager/diagramming/matching/page', {
                      params: {
                        dataSource: 2,
                        page: 1,
                        limit: this.matchingPagination.pageSize,
                        projectManagementId: this.projectid,
                      },
                    })
                    .then((res) => {
                      if (res.code === 0) {
                        this.coordinatesFailedList = res.data.list || []
                        this.matchingPagination.total = Number(res.data.total) || 0
                      }
                    })
                }

                this.$message.success('删除成功')
              } else {
                this.$message.error(res.message || '删除失败')
              }
            })
            .catch((error) => {
              console.error('删除失败:', error)
              this.$message.error('删除失败')
            })
        },
      })
    },
    // 纠错弹窗方法 - 使用模糊坐标
    handleCorrectionUseFuzzyCoordinates() {
      if (!this.selectedCorrectionPoints.length) {
        this.$message.warning('请选择要使用模糊坐标的点')
        return
      }

      // 获取选中的点的物探点号
      const selectedPoints = this.selectedCorrectionPoints.map((index) => ({
        intuitionPoint: this.coordinatesFailedList[index].intuitionPoint,
      }))

      // 调用模糊坐标接口
      this.$http
        .post('/gis-manager/diagramming/point/fuzzy/coordinates', {
          queryMethod: 2, //1.写入数据库前查询，2.写入数据库后查询
          pipePointList: selectedPoints,
          projectManagementId: this.projectid, // 使用projectid替代currentCorrectionProjectId
        })
        .then((res) => {
          if (res.code === 0 && res.data && res.data.pipePointList) {
            // 更新选中点的坐标信息
            const fuzzyPoints = new Map(res.data.pipePointList.map((point) => [point.intuitionPoint, point]))

            this.coordinatesFailedList = this.coordinatesFailedList.map((point, index) => {
              if (this.selectedCorrectionPoints.includes(index)) {
                const fuzzyPoint = fuzzyPoints.get(point.intuitionPoint)
                if (fuzzyPoint) {
                  return {
                    ...point,
                    measurementLongitude: fuzzyPoint.measurementLongitude,
                    measurementLatitude: fuzzyPoint.measurementLatitude,
                    groundElevation: fuzzyPoint.groundElevation,
                  }
                }
              }
              return point
            })

            this.$message.success('模糊坐标应用成功')
          } else {
            this.$message.error(res.message || '获取模糊坐标失败')
          }
        })
        .catch((error) => {
          console.error('获取模糊坐标失败:', error)
          this.$message.error('获取模糊坐标失败')
        })
    },
    // 纠错弹窗方法 - 保存
    handleSaveCorrectionPoints() {
      // 验证选中的点是否都填写完整
      const selectedPoints = this.selectedCorrectionPoints.map((index) => {
        const point = { ...this.coordinatesFailedList[index] }
        // 确保 groundElevation 为有效值
        if (point.groundElevation === '') {
          point.groundElevation = null
        }
        return point
      })

      const invalidPoints = selectedPoints.filter((point) => !this.checkPointComplete(point))

      if (invalidPoints.length > 0) {
        this.$message.error('选中的点必须填写完整所有坐标信息')
        return
      }

      // 更新pipePointInfoPcList
      selectedPoints.forEach((point) => {
        const existingIndex = this.pipePointInfoPcList.findIndex((p) => p.intuitionPoint === point.intuitionPoint)

        if (existingIndex !== -1) {
          // 如果找到相同物探点号的点，更新其坐标信息
          this.pipePointInfoPcList[existingIndex] = {
            ...this.pipePointInfoPcList[existingIndex],
            measurementLongitude: point.measurementLongitude,
            measurementLatitude: point.measurementLatitude,
            groundElevation: point.groundElevation,
            coordinatesMatch: 1,
          }
        } else {
          // 如果没有找到，添加到pipePointInfoPcList
          this.pipePointInfoPcList.push({
            ...point,
            coordinatesMatch: 1,
          })
        }
      })

      // 调用统一的更新接口
      this.$http
        .post('/gis-manager/diagramming/point/update/fuzzy/coordinates', {
          projectManagementId: this.projectid,
          pipePointInfoPcList: this.pipePointInfoPcList,
          // 传递选中的点数据
          coordinatesFailedList: selectedPoints,
          pointDuplicateDataList: this.pointDuplicateDataList,
        })
        .then((res) => {
          if (res.code === 0) {
            // 从coordinatesFailedList中移除已保存的点
            this.coordinatesFailedList = this.coordinatesFailedList.filter(
              (_, index) => !this.selectedCorrectionPoints.includes(index)
            )

            // 清空选择
            this.selectedCorrectionPoints = []
            this.hasSelectedCorrectionPoints = false

            // 如果当前页没有数据了，跳转到第一页
            if (this.coordinatesFailedList.length === 0) {
              this.matchingPagination.current = 1
              // 重新获取第一页数据
              this.$http
                .get('/gis-manager/diagramming/matching/page', {
                  params: {
                    dataSource: 2,
                    page: 1,
                    limit: this.matchingPagination.pageSize,
                    projectManagementId: this.projectid,
                  },
                })
                .then((res) => {
                  if (res.code === 0) {
                    this.coordinatesFailedList = res.data.list || []
                    this.matchingPagination.total = Number(res.data.total) || 0
                  }
                })
            }

            this.$message.success('保存成功')
          } else {
            this.$message.error(res.message || '保存失败')
          }
        })
        .catch((error) => {
          console.error('保存失败:', error)
          this.$message.error('保存失败')
        })
    },
    // 检查纠错弹窗物探点的记录属性
    getCorrectionDuplicateCheckboxProps(record, index) {
      // 如果记录不完整，禁用复选框
      if (!this.checkPointComplete(record)) {
        return {
          props: {
            disabled: true,
            checked: false,
          },
        }
      }

      // 检查是否有相同物探点号的记录已被选中
      const hasSamePointSelected = this.selectedCorrectionDuplicatePoints.some((key) => {
        const selectedRecord = this.pointDuplicateDataList[key]
        return selectedRecord && selectedRecord.intuitionPoint === record.intuitionPoint && key !== index
      })

      return {
        props: {
          disabled: hasSamePointSelected,
          checked: this.selectedCorrectionDuplicatePoints.includes(index),
        },
      }
    },

    // 获取纠错弹窗物探点重复的行类名
    getCorrectionDuplicateRowClassName(record, index) {
      // 如果该行被选中，添加高亮类名
      if (this.selectedCorrectionDuplicatePoints.includes(index)) {
        return 'selected-row'
      }
      return ''
    },

    // 纠错弹窗物探点重复 - 选择变更
    onCorrectionDuplicatePointSelectionChange(selectedKeys) {
      // 获取新增的选中项
      const newlySelected = selectedKeys.filter((key) => !this.selectedCorrectionDuplicatePoints.includes(key))

      // 如果有新增选中项
      if (newlySelected.length > 0) {
        const finalSelectedKeys = [...this.selectedCorrectionDuplicatePoints]

        // 对每个新选中的项
        newlySelected.forEach((newKey) => {
          const newRecord = this.pointDuplicateDataList[newKey]
          if (!newRecord) return

          // 移除已选中的相同物探点号的记录
          const samePointKeys = finalSelectedKeys.filter((oldKey) => {
            const oldRecord = this.pointDuplicateDataList[oldKey]
            return oldRecord && oldRecord.intuitionPoint === newRecord.intuitionPoint
          })

          // 从已选中项中移除相同物探点号的记录
          samePointKeys.forEach((key) => {
            const index = finalSelectedKeys.indexOf(key)
            if (index > -1) {
              finalSelectedKeys.splice(index, 1)
            }
          })

          // 添加新选中的项
          finalSelectedKeys.push(newKey)
        })

        // 更新选中状态
        this.selectedCorrectionDuplicatePoints = finalSelectedKeys
      } else {
        // 如果是取消选中，直接更新
        this.selectedCorrectionDuplicatePoints = selectedKeys
      }

      this.hasSelectedCorrectionDuplicatePoints = this.selectedCorrectionDuplicatePoints.length > 0
    },

    // 使用纠错弹窗物探点重复点
    handleUseCorrectionDuplicatePoint(record, index) {
      if (!this.checkPointComplete(record)) {
        this.$message.warning('请先填写完整坐标信息')
        return
      }

      // 获取物探点号
      const pointName = record.intuitionPoint

      // 清除同一物探点号的其他选中项
      this.selectedCorrectionDuplicatePoints = this.selectedCorrectionDuplicatePoints.filter((key) => {
        const selectedRecord = this.pointDuplicateDataList[key]
        return !selectedRecord || selectedRecord.intuitionPoint !== pointName
      })

      // 选中当前项
      if (!this.selectedCorrectionDuplicatePoints.includes(index)) {
        this.selectedCorrectionDuplicatePoints.push(index)
        this.hasSelectedCorrectionDuplicatePoints = true
      }

      this.$message.success(`已选择物探点 ${pointName} 的坐标`)
    },

    // 保存纠错弹窗物探点重复点
    handleSaveCorrectionDuplicatePoints() {
      // 获取选中的点
      const selectedPoints = this.selectedCorrectionDuplicatePoints.map((index) => {
        const point = { ...this.pointDuplicateDataList[index] }
        // 确保 groundElevation 为有效值
        if (point.groundElevation === '') {
          point.groundElevation = null
        }
        return point
      })

      // 验证选中的点是否都填写完整
      const invalidPoints = selectedPoints.filter((point) => !this.checkPointComplete(point))
      if (invalidPoints.length > 0) {
        this.$message.error('选中的点必须填写完整所有坐标信息')
        return
      }

      // 获取选中点的物探点号
      const selectedPointNames = new Set(selectedPoints.map((point) => point.intuitionPoint))

      // 获取所有相同物探点号的点(包括选中的点和未选中但物探点号相同的点)
      const allRelatedPoints = this.pointDuplicateDataList.filter((point) =>
        selectedPointNames.has(point.intuitionPoint)
      )

      // 更新点信息
      const uniquePoints = new Map()
      selectedPoints.forEach((point) => {
        uniquePoints.set(point.intuitionPoint, true)
      })

      // 更新pipePointInfoPcList中的点
      selectedPoints.forEach((point) => {
        const existingIndex = this.pipePointInfoPcList.findIndex((p) => p.intuitionPoint === point.intuitionPoint)
        if (existingIndex !== -1) {
          // 如果找到相同物探点号的点，更新其坐标信息
          this.pipePointInfoPcList[existingIndex] = {
            ...this.pipePointInfoPcList[existingIndex],
            measurementLongitude: point.measurementLongitude,
            measurementLatitude: point.measurementLatitude,
            groundElevation: point.groundElevation,
            coordinatesMatch: 1,
          }
        } else {
          // 如果没有找到，添加到pipePointInfoPcList
          this.pipePointInfoPcList.push({
            ...point,
            coordinatesMatch: 1,
          })
        }
      })

      // 调用统一的更新接口
      this.$http
        .post('/gis-manager/diagramming/point/update/fuzzy/coordinates', {
          projectManagementId: this.projectid,
          pipePointInfoPcList: this.pipePointInfoPcList,
          coordinatesFailedList: this.coordinatesFailedList,
          // 传递所有相关点数据(包括选中点和相同物探点号的点)
          pointDuplicateDataList: allRelatedPoints,
        })
        .then((res) => {
          if (res.code === 0) {
            // 更新pointDuplicateDataList - 移除已保存的点及其相关点
            this.pointDuplicateDataList = this.pointDuplicateDataList.filter((point) => {
              return !uniquePoints.has(point.intuitionPoint)
            })

            // 清空选中状态
            this.selectedCorrectionDuplicatePoints = []
            this.hasSelectedCorrectionDuplicatePoints = false

            // 如果当前页没有数据了，跳转到第一页
            if (this.pointDuplicateDataList.length === 0) {
              this.correctionDuplicatePagination.current = 1
              // 重新获取第一页数据
              this.$http
                .get('/gis-manager/diagramming/duplicate/page', {
                  params: {
                    dataSource: 2,
                    page: 1,
                    limit: this.correctionDuplicatePagination.pageSize,
                    projectManagementId: this.projectid,
                  },
                })
                .then((res) => {
                  if (res.code === 0) {
                    this.pointDuplicateDataList = res.data.list || []
                    this.correctionDuplicatePagination.total = Number(res.data.total) || 0
                  }
                })
            }

            this.$message.success('保存成功')
          } else {
            this.$message.error(res.message || '保存失败')
          }
        })
        .catch((error) => {
          console.error('保存失败:', error)
          this.$message.error('保存失败')
        })
    },

    // 写入数据库
    handleWriteToDatabase() {
      // 验证是否有数据需要写入
      if (this.pipePointInfoPcList.length === 0) {
        this.$message.warning('没有可写入的数据')
        return
      }

      this.submitting = true

      this.$http
        .post('/gis-manager/diagramming/point/update/fuzzy/coordinates', {
          projectManagementId: this.projectid,
          pipePointInfoPcList: this.pipePointInfoPcList,
          coordinatesFailedList: this.coordinatesFailedList,
          pointDuplicateDataList: this.pointDuplicateDataList,
        })
        .then((res) => {
          if (res.code === 0) {
            this.loadingSpinnerSuccess = true

            setTimeout(() => {
              this.loadingSpinnerSuccess = false
              this.submitting = false

              // 关闭弹窗
              this.listFailedDialogVisible = false
              // 刷新列表
              this.queryList()

              this.$message.success('写入数据库成功')
            }, 1000)
          } else {
            this.submitting = false
            this.$message.error(res.message || '写入数据库失败')
          }
        })
        .catch((error) => {
          console.error('写入数据库失败:', error)
          this.submitting = false
          this.$message.error('写入数据库失败')
        })
    },

    confirmClosePreviewResults() {
      this.$confirm({
        title: '确认关闭',
        content: '当前还未写入数据库，确定要关闭吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          this.PreviewResultsDigital = false
          this.handleCancel()
        },
      })
    },
    // 纠错弹窗物探点重复分页变化处理
    handleCorrectionDuplicatePageChange(pagination) {
      this.correctionDuplicatePagination.current = pagination.current

      // 如果是从列表进入的纠错弹窗,使用 dataSource: 2
      if (this.listFailedDialogVisible) {
        this.$http
          .get('/gis-manager/diagramming/duplicate/page', {
            params: {
              dataSource: 2, // 从列表进入时使用 2
              page: pagination.current,
              limit: this.correctionDuplicatePagination.pageSize,
              projectManagementId: this.projectid,
            },
          })
          .then((res) => {
            if (res.code === 0) {
              this.pointDuplicateDataList = res.data.list || []
              this.correctionDuplicatePagination.total = Number(res.data.total) || 0
            }
          })
      } else {
        // 直接操作时使用原来的方法
        this.fetchDuplicatePoints()
      }
    },

    // 获取纠错弹窗物探点重复列表
    fetchCorrectionDuplicatePoints(id) {
      if (!id) return

      this.submitting = true
      this.$http
        .get('/gis-manager/diagramming/duplicate/page', {
          params: {
            dataSource: 2,
            page: this.correctionDuplicatePagination.current,
            limit: this.correctionDuplicatePagination.pageSize,
            projectManagementId: id,
          },
        })
        .then((res) => {
          if (res.code === 0) {
            this.pointDuplicateDataList = res.data.list || []
            this.correctionDuplicatePagination.total = Number(res.data.total) || 0

            // 更新选中状态
            this.selectedCorrectionDuplicatePoints = []

            // 自动选择与结果预览数据中坐标完全匹配的点
            if (this.pointDuplicateDataList.length > 0 && this.pipePointInfoPcList.length > 0) {
              const matchingPointsIndices = this.pointDuplicateDataList
                .map((duplicatePoint, index) => {
                  // 查找在结果预览数据中是否有完全匹配的点
                  const matchingPreviewPoint = this.pipePointInfoPcList.find(
                    (previewPoint) =>
                      previewPoint.intuitionPoint === duplicatePoint.intuitionPoint &&
                      previewPoint.measurementLongitude === duplicatePoint.measurementLongitude &&
                      previewPoint.measurementLatitude === duplicatePoint.measurementLatitude &&
                      previewPoint.groundElevation === duplicatePoint.groundElevation
                  )
                  return matchingPreviewPoint ? index : null
                })
                .filter((index) => index !== null)

              // 如果找到匹配的点，选择它们
              if (matchingPointsIndices.length > 0) {
                this.selectedCorrectionDuplicatePoints = matchingPointsIndices
                this.hasSelectedCorrectionDuplicatePoints = true
              }
            }

            this.submitting = false
          } else {
            this.$message.error(res.message || '获取物探点重复数据失败')
            this.submitting = false
          }
        })
        .catch((error) => {
          console.error('获取物探点重复数据失败:', error)
          this.$message.error('获取物探点重复数据失败')
          this.submitting = false
        })
    },
    // 在 CoordinateMatching.vue 中添加删除方法
    handleDelete(id) {
      const _this = this
      this.$confirm({
        title: '确认删除',
        content: '是否确认删除该记录？删除后不可恢复！',
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          try {
            const res = await _this.$http.get(`/gis-manager/diagramming/project/remove/${id}`)
            if (res.code === 0) {
              _this.$message.success('删除成功')
              // 重新加载数据
              _this.queryList()
            }
          } catch (error) {
            console.error('删除失败:', error)
            _this.$message.error('删除失败')
          }
        },
      })
    },
    showpoint(record) {
      this.projectManagementId = record.id
      ;(this.pointForm = {
        coordinatesMatch: '',
        closingPoints: '',
        intuitionPoint: '',
      }),
        this.getPointList()
    },
    showline(record) {
      this.projectManagementId = record.id
      ;(this.lineForm = {
        connectionPointNumber: '',
        theDotNumberIsConnected: '',
      }),
        this.getLineList()
    },
    //管线统计
    showstatistics(record) {
      this.statisticsList = []
      this.$http.get('/gis-manager/diagramming/project/Pipeline/statistics/' + record.id).then((res) => {
        let value = res.data
        if (value.length > 0) {
          value.map((item) => {
            this.statisticsList.push({
              tubeClassName: item.tubeClassName,
              data: [
                { type: '点', value: item.numberOfPoints },
                { type: '线', value: item.lineQuantity },
                { type: '管线长度', value: item.pipeNetworkLength + 'm' },
              ],
            })
          })
        }
        this.statisticsDialog = true
      })
    },
    getPointList(item) {
      this.$http
        .get('/gis-manager/diagramming/point/page', {
          params: {
            intuitionPoint: this.pointForm.intuitionPoint,
            closingPoints: this.pointForm.closingPoints,
            coordinatesMatch: this.pointForm.coordinatesMatch,
            projectManagementId: this.projectManagementId,
            page: this.pointlistpage.current,
            limit: this.pointlistpage.pageSize,
          },
        })
        .then((res) => {
          let data = res.data
          this.pointList = data.list
          this.pointlistpage.total = Number(data.total)
          this.pointlistDialog = true
        })
    },
    //线
    getLineList(item) {
      this.$http
        .get('/gis-manager/diagramming/pipe/page', {
          params: {
            theDotNumberIsConnected: this.lineForm.theDotNumberIsConnected,
            connectionPointNumber: this.lineForm.connectionPointNumber,
            projectManagementId: this.projectManagementId,
            page: this.linelistpage.current,
            limit: this.linelistpage.pageSize,
          },
        })
        .then((res) => {
          let data = res.data
          this.lineList = data.list
          this.linelistpage.total = Number(data.total)
          this.linelistDialog = true
        })
    },
    pointpageChange(pagination, filters, sorter) {
      this.pointlistpage.current = pagination.current
      this.pointlistpage.pageSize = pagination.pageSize
      this.getPointList()
    },
    linepageChange(pagination, filters, sorter) {
      this.linelistpage.current = pagination.current
      this.linelistpage.pageSize = pagination.pageSize
      this.getLineList()
    },
  },
  computed: {
    // 其他计算属性...
  },
  watch: {
    selectedMissingPoints(val) {
      if (this.missingPointsRowSelection) {
        this.missingPointsRowSelection.selectedRowKeys = val
      }
    },
  },
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  min-height: 100%;
  background: #f0f2f5;

  /deep/ .ant-card-bordered {
    border: none;
  }
}

.box-card {
  margin-bottom: 0;
}

.list-card {
  margin-top: 24px;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
}

.form-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.label {
  min-width: 100px;
  text-align: right;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}

.select-input {
  width: 400px;
}

.preview-btn {
  margin-left: 100px;
  height: 40px;
  padding: 0 32px;
  font-size: 16px;
}

.preview-content {
  padding: 0 24px;
}

.tables-container {
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
}

.table-box {
  flex: 1;
  min-width: 0;

  .table-title {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 5px;
  }

  .preview-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  :deep(.ant-table-body) {
    min-height: 200px;
  }
}

.bottom-table {
  margin-top: 24px;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-top: 1px solid #f0f0f0;
  margin: 24px -24px -16px;
}

.right-buttons {
  display: flex;
  gap: 8px;
}

.notice-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 16px;
}

.notice-icon {
  width: 24px;
  height: 24px;
}

.notice-title {
  font-size: 16px;
  font-weight: 500;
}

.notice-content {
  padding: 0 16px;
}

.warning-text {
  color: #eda007;
  margin-bottom: 16px;
  font-size: 14px;
}

.points-list {
  background: #f5f5f5;
  padding: 16px;
  border-radius: 4px;
  max-height: 400px;
  overflow-y: auto;
}

.point-item {
  background: #fff;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
}

.point-header {
  font-weight: 500;
  color: #1890ff;
  margin-bottom: 8px;
}

.point-details {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
}

.detail-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-page-search-submitButtons {
  margin-top: 16px;
  display: block;
}

/deep/ .ant-table-tbody > tr > td {
  text-align: center;
  height: 40px;
  padding: 8px 16px;
  line-height: 24px;
}

/deep/ .ant-table-thead > tr > th {
  height: 40px;
  padding: 8px 16px;
}

/deep/ .ant-tabs-tab {
  font-size: 14px;
  padding: 8px 16px;
}

/deep/ .ant-modal-body {
  padding: 24px;
}

.table-footer {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0;

  .button-group {
    display: flex;
    gap: 8px;
  }
}

.button-container {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
}

.warning-box {
  display: flex;
  align-items: center;
  background-color: #fff1f0;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 16px;

  .warning-icon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  .warning-text {
    color: #eda007;
    font-size: 14px;
    margin: 0;
  }
}

/deep/ .ant-radio-button-wrapper {
  padding: 0 12px;
  height: 24px;
  line-height: 22px;
  font-size: 12px;
}

.selected-row {
  background-color: #02c62f !important;
}

/deep/ .selected-row td {
  background-color: #02c62f !important;
  height: 40px !important;
  padding: 8px 16px !important;
  line-height: 24px !important;
  color: #fff !important;
}

/deep/ .correction-modal-right {
  position: absolute;
  top: 0;
  right: -14px;

  .ant-modal {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    padding: 0;
    height: 100vh;
    max-width: 40%;
    width: 40% !important;
  }

  .ant-modal-content {
    height: 100vh;
    border-radius: 0;
    display: flex;
    flex-direction: column;
  }

  .ant-modal-body {
    flex: 1;
    overflow-y: auto;
  }
}
.tab {
  font-size: 16px;
  font-weight: normal;
  border-collapse: collapse;

  tr td {
    height: 50px;
    border: 1px solid #d5ecfc;
  }

  tr th {
    width: 33.33%;
    /* 假设你有三个表头，每个占1/3 */
    height: 50px;
  }
}
</style>
